import moment from 'moment';

const DATE_FORMAT = 'DD-MM-YYYY';

const getFormattedDate = (date) => (moment(date).format(DATE_FORMAT));

export default getFormattedDate;
